<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/relocation/bg.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <h4 class="text-center" style="font-weight: 600; color: #fff">
          {{ pageContent.header }}
        </h4>
        <br />
        <div class="row d-flex align-items-stretch">
          <div class="col-md-12 d-flex">
            <div class="dz-bnr-inr-entryh-100" style="text-align: left">
              <p
                class="text-center mb-2 text-white"
                style="font-size: 16px; text-align: left"
              >
                {{ pageContent.intro }}
              </p>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div class="row">
          <div class="col-md-6">
            <div
              class="dz-bnr-inr dz-bnr-inr-sm text-center mb-3"
              style="
                background-image: url(/assets/images/relocation/bg2.png);
                background-size: cover;
                background-position: bottom;
                padding: 50px 50px;
                min-height: 300px;
                height: auto;
              "
            >
              <div class="row">
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(1)"
                  :class="{ selected: selectedEssential === 1 }"
                >
                  <img
                    src="assets/images/relocation/1.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 1 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_electricity }}
                  </h5>
                </div>
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(2)"
                  :class="{ selected: selectedEssential === 2 }"
                >
                  <img
                    src="assets/images/relocation/2.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 2 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_water }}
                  </h5>
                </div>
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(3)"
                  :class="{ selected: selectedEssential === 3 }"
                >
                  <img
                    src="assets/images/relocation/3.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 3 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_gas }}
                  </h5>
                </div>
              </div>
              <br />
              <br />
              <div class="row">
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(4)"
                  :class="{ selected: selectedEssential === 4 }"
                >
                  <img
                    src="assets/images/relocation/7.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 4 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_garbage }}
                  </h5>
                </div>
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(5)"
                  :class="{ selected: selectedEssential === 5 }"
                >
                  <img
                    src="assets/images/relocation/5.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 5 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_internet }}
                  </h5>
                </div>
                <div
                  class="col-4 col-md-4"
                  @click="selectEssential(6)"
                  :class="{ selected: selectedEssential === 6 }"
                >
                  <img
                    src="assets/images/relocation/6.png"
                    class="img-fluid d-block mx-auto"
                    :class="{ 'img-selected': selectedEssential === 6 }"
                    alt=""
                  />
                  <h5 class="text-center text-white" style="font-weight: 400">
                    {{ pageContent.categories_mobile }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div
              class="dz-bnr-inr-entry mt-4 opacity-white text-left"
              style="text-align: left"
            >
              <br />
              <div v-if="selectedEssential == 1">
                <h5 class="text-left text-black">
                  Setting Up Electricity in Florida
                </h5>
                <p class="text-black" style="font-weight: 400">
                  Powering your new home is simple! Electricity service in
                  Florida is provided by a few major utility companies,
                  depending on your location. The most common providers include:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.tampaelectric.com/" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Tampa Electric<br />(TECO)
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Most of the City of Tampa, Hillsborough
                        County, and parts of Polk, Pasco, and Pinellas
                        Counties<br /><br />
                        Phone: 813-223-0800 (Hillsborough), 888-223-0800 (All
                        other areas)
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.facebook.com/duke.energy/" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Duke Energy<br />Florida
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Parts of Pinellas County, St. Petersburg,
                        Clearwater, and areas north and west of Tampa<br /><br />
                        Phone: 800-700-8744
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.wrec.net/" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Withlacoochee River Electric Cooperative (WREC)
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Citrus, Hernando, Pasco, Polk, and Sumter
                        counties. Common cities include Dade City, Zephyrhills,
                        Brooksville, Crystal River, and Inverness.<br /><br />
                        Phone: 352-567-5133
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <p class="text-black">
                  We recommend contacting the provider that services your
                  address a few days before your move-in date to start service.
                </p>
              </div>
              <div v-else-if="selectedEssential == 2">
                <h5 class="text-left text-black">
                  Setting Up Water Service in Florida
                </h5>
                <p class="text-black" style="font-weight: 400">
                  Water services in Florida are managed by local city or county
                  utilities. To initiate service, please contact the appropriate
                  provider for your area:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.tampa.gov/water" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          City of Tampa<br />Water Department
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Most areas within City of Tampa limits<br /><br />
                        Phone: 813-274-8811
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a
                        href="https://pinellas.gov/department/utilities/"
                        target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Pinellas County<br />Utilities
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Unincorporated areas of Pinellas
                        County<br /><br />
                        Phone: 727-464-4000
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.stpete.org/water" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          City of St.<br />Petersburg Water
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Properties within the City of St.
                        Petersburg limits<br /><br />
                        Phone: 727-893-7341
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <p class="text-black">
                  To start service, visit the appropriate utility's website or
                  call their office. You'll typically need your address, move-in
                  date, and personal identification to get started.
                </p>
              </div>
              <div v-else-if="selectedEssential == 3">
                <h5 class="text-left text-black">
                  Setting Up Gas Service in Florida
                </h5>
                <p class="text-black" style="font-weight: 400">
                  Natural gas service is available in select areas across
                  Florida and is primarily provided by regional utilities. If
                  your new home uses natural gas, here are the most common
                  providers:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.peoplesgas.com/" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          TECO Peoples Gas
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Tampa, St. Petersburg, Orlando,
                        Jacksonville, Miami, and other major cities<br /><br />
                        Phone: 877-832-6747
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://fpuc.com/" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Florida Public Utilities (FPU)
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Operates approximately 3,154 miles of
                        natural gas distribution mains across 25 counties in
                        Florida<br /><br />
                        Phone: 800-427-7712
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://www.floridacitygas.com/" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Florida City Gas
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Serves parts of eight counties in
                        Florida<br /><br />
                        Phone: 888-352-5325
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <p class="text-black">
                  Check with your landlord or property manager to confirm
                  whether your property uses natural gas and who the local
                  provider is.
                </p>
              </div>
              <div v-else-if="selectedEssential == 4">
                <h5 class="text-left text-black">
                  Stress-Free Solid Waste Setup for Your New Home
                </h5>
                <p class="text-black" style="font-weight: 400">
                  In Florida, garbage, recycling, and yard waste collection is
                  typically managed by your city or county government. Services,
                  schedules, and providers vary depending on where you live.
                  Here are the most common ones:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a
                        href="https://www.tampa.gov/solid-waste"
                        target="_blank"
                      >
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          City of Tampa Solid Waste Department
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Properties within Tampa city limits<br /><br />
                        Phone: 813-274-8811
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://hcfl.gov/" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Hillsborough County – Solid Waste Management
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Unincorporated areas of Hillsborough
                        County (Brandon, Riverview, Valrico, etc.)<br /><br />
                        Phone: 813-272-5680
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a
                        href="https://www.stpete.org/sanitation"
                        target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          City of St. Petersburg – Sanitation Department
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        <b>Covers:</b> Homes within St. Pete city limits<br /><br />
                        Phone: 727-893-7398
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <p class="text-black">
                  Trash services are often automatically set up with water or
                  utility services. If not, contact your city or county to
                  request bins and view pickup schedules.
                </p>
              </div>
              <div v-else-if="selectedEssential == 5">
                <h5 class="text-left text-black">
                  Setting Up Internet Service in Florida
                </h5>
                <p class="text-black">
                  Florida has a variety of internet service providers, with
                  availability depending on your exact location. Here's a list
                  of the most common and reliable providers in the Tampa Bay
                  region:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://spectrum.com" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Spectrum
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        One of the most widely available providers in Tampa, St.
                        Petersburg, Clearwater, and surrounding suburbs<br /><br />
                        Phone: 855-243-8892
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-0"
                    >
                      <a href="https://frontier.com/" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Frontier Communications
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        Available in parts of Tampa, Brandon, and surrounding
                        areas<br /><br />
                        Phone: 800-921-8101
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://xfinity.com" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Xfinity by Comcast
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        Available in select areas of Florida, including parts of
                        Pinellas County<br /><br />
                        Phone: 800-934-6489
                      </div>
                    </div>
                  </div>
                </div>
                <p class="text-black">
                  To set up service, visit the provider’s website or call their
                  customer service line
                </p>
              </div>
              <div v-else-if="selectedEssential == 6">
                <h5 class="text-left text-black">
                  Setting Up Mobile Phone Service
                </h5>
                <p class="text-black" style="font-weight: 400">
                  If you’re relocating to Florida, setting up a mobile phone
                  plan is quick and easy. Whether you need a prepaid option or
                  unlimited data, here are the most common mobile carriers
                  available statewide:
                </p>
                <br />
                <div class="container">
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://verizon.com" target="_blank">
                        <h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          Verizon Wireless
                        </h4>
                      </a>
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        Known for strong coverage across Florida, especially in
                        urban and suburban areas<br /><br />
                        Phone: 800-922-0204
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://att.com/" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          AT&T
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        Reliable network in both metro and rural areas<br /><br />
                        Phone: 800-331-0500
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row align-items-stretch">
                    <div
                      class="col-md-5 d-flex flex-column justify-content-center bg-primary text-white text-center p-3"
                    >
                      <a href="https://t-mobile.com" target="_blank"
                        ><h4 class="text-white  fs-5 fs-md-4" style="font-weight: 400">
                          T-Mobile
                        </h4></a
                      >
                    </div>
                    <div
                      class="col-md-7 d-flex flex-column justify-content-center bg-white text-primary p-3"
                    >
                      <div>
                        Great coverage in major cities like Tampa, St. Pete, and
                        Orlando<br /><br />
                        Phone: 800-937-8997
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
 
 <script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      selectedEssential: 1,
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
    };
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    selectEssential(id) {
      this.selectedEssential = id;
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.essentials[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };
        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>
 
 <style scoped>
.img-selected {
  filter: sepia(1) saturate(40) hue-rotate(0deg) brightness(1);
  transition: filter 0.3s ease;
}
.opacity-white {
  background-color: rgba(255, 255, 255, 0.7); /* White with 80% opacity */
  padding: 10px 20px;
  border-radius: 10px;
  color: black;
}
.dz-bnr-inr-entry ul li {
  list-style: inside;
}
h4 {
  white-space: normal;
  overflow-wrap: break-word;
}
</style>
 